module.exports = ( typeof window === 'undefined' ? null : window );
